module.exports = __webpack_public_path__ + "img/data1.e1c4a3cf.png";